import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { PurchasePlusBaseErrorFragmentDoc } from './BaseError.generated'
import * as Types from './purchasePlus_graphql'

export const CreateRequisitionLineDocument = gql`
  mutation CreateRequisitionLine($input: CreateRequisitionLineInput!) {
    createRequisitionLine(input: $input) {
      requisitionLine {
        id
        uuid
        quantity
        requisition {
          id
          advanced
          totalValue
          totalTaxValue
          totalValueExcludingTax
          requisitionLines {
            unpaginated {
              id
              uuid
              quantity
            }
          }
        }
      }
      errors {
        ...PurchasePlusBaseError
      }
    }
  }
  ${PurchasePlusBaseErrorFragmentDoc}
` as unknown as DocumentNode<Types.CreateRequisitionLineMutation, Types.CreateRequisitionLineMutationVariables>
